<template>
  <div v-if="!isMobile">
    <div id="landing_charts" class="column landing_charts">
      <div class="title_insights">
        <h1 style="text-transform: uppercase">
          {{ $t("msg.performance") }}
        </h1>
      </div>

      <div class="wrapper_chart_insights">
        <p class="expand_chart" @click="toggleModalExpandChart()">
          {{ $t("msg.expand_chart") }}
          <img
            src="../../assets/images/external-link.svg"
            alt="external-link"
          />
        </p>
        <a class="price_history" href="#" @click="toggleModalPriceHist()">{{
          $t("msg.price_history_list")
        }}</a>

        <div class="period">
          <img src="../../assets/images/blue_icon.svg" alt="blue_token" />
          <p>{{ $t("msg.g_l") }}:</p>

          <span
            v-if="this.chartMode == 'hour'"
            :style="positiveTotal ? 'color:#22c9b6' : 'color:red'"
            >{{ getPercentChangeHour() }}</span
          >

          <span
            v-if="this.chartMode == 'week'"
            :style="positiveTotal ? 'color:#22c9b6' : 'color:red'"
            >{{ getPercentChangeWeek() }}</span
          >

          <span
            v-if="this.chartMode == 'day'"
            :style="positiveTotal ? 'color:#22c9b6' : 'color:red'"
            >{{ getPercentChangeDay() }}</span
          >

          <span
            v-if="this.chartMode == 'month'"
            :style="positiveTotal ? 'color:#22c9b6' : 'color:red'"
            >{{ getPercentChangeMonth() }}</span
          >

          <span
            v-if="this.chartMode == 'year'"
            :style="positiveTotal ? 'color:#22c9b6' : 'color:red'"
            >{{ getPercentChangeYear() }}</span
          >

          <span
            v-if="this.chartMode == 'ytd'"
            :style="positiveTotal ? 'color:#22c9b6' : 'color:red'"
            >{{ getPercentChangeYTD() }}</span
          >

          <span
            v-if="this.chartMode == 'all'"
            :style="positiveTotal ? 'color:#22c9b6' : 'color:red'"
            >{{ getPercentChangeAll() }}</span
          >
        </div>
      </div>

      <div class="column landing_charts_label p0">
        <div style="display: flex; align-items: center">
          <span class="landing_charts_label_block"></span>
          <p>
            {{ $tc("msg.price", 1) }}
            <strong>BLUE | USDT</strong>
          </p>
        </div>
        <div
          class="combo_buttons_charts"
          :class="{ loading_action: chartLoading }"
        >
          <!-- <a
            class="link_switch"
            style="padding: 0 5px !important"
            @click="toggleChart('hour')"
            :class="{ link_switch_active: chartMode == 'hour' }"
            :disabled="chartMode == 'hour' || chartLoading"
            >1H</a
          > -->
          <a
            class="link_switch"
            style="padding: 0 5px !important"
            @click="toggleChart('day')"
            :class="{ link_switch_active: chartMode == 'day' }"
            :disabled="chartMode == 'day' || chartLoading"
            >1D</a
          >
          <a
            class="link_switch"
            style="padding: 0 5px !important"
            @click="toggleChart('week')"
            :class="{ link_switch_active: chartMode == 'week' }"
            :disabled="chartMode == 'week' || chartLoading"
            >1{{ $t("msg.w") }}</a
          >
          <a
            class="link_switch"
            style="padding: 0 5px !important"
            @click="toggleChart('month')"
            :class="{ link_switch_active: chartMode == 'month' }"
            :disabled="chartMode == 'month' || chartLoading"
            >1M</a
          >
          <a
            class="link_switch"
            style="padding: 0 5px !important"
            @click="toggleChart('year')"
            :class="{ link_switch_active: chartMode == 'year' }"
            :disabled="chartMode == 'year' || chartLoading"
            >1Y</a
          >
          <a
            class="link_switch"
            style="padding: 0 5px !important"
            @click="toggleChart('ytd')"
            :class="{ link_switch_active: chartMode == 'ytd' }"
            :disabled="chartMode == 'ytd' || chartLoading"
            >YTD</a
          >
          <a
            class="link_switch"
            style="padding: 0 5px !important"
            @click="toggleChart('all')"
            :class="{ link_switch_active: chartMode == 'all' }"
            :disabled="chartMode == 'all' || chartLoading"
            >{{ $t("msg.all") }}</a
          >
        </div>
      </div>

      <div class="column">
        <chart-line-custom
          @chartLoaded="setChartLoading(false)"
          @chartLoading="setChartLoading(true)"
          :chartData="chartParams"
          :bluValue="bluValue[0]"
        ></chart-line-custom>
      </div>
    </div>
  </div>

  <div class="tabs_mobile" v-else>
    <div class="tab">
      <input class="tab_input" type="checkbox" id="landing_charts" />
      <label class="tab-label">
        {{ $t("msg.performance") }}
        <div class="period">
          <div style="display: flex">
            <img src="../../assets/images/blue_icon.svg" alt="blue_token" />
            <p>{{ $t("msg.g_l") }}:</p>
          </div>

          <span
            v-if="this.chartMode == 'hour'"
            :style="positiveTotal ? 'color:#22c9b6' : 'color:red'"
            >{{ getPercentChangeHour() }}</span
          >

          <span
            v-if="this.chartMode == 'week'"
            :style="positiveTotal ? 'color:#22c9b6' : 'color:red'"
            >{{ getPercentChangeWeek() }}</span
          >

          <span
            v-if="this.chartMode == 'day'"
            :style="positiveTotal ? 'color:#22c9b6' : 'color:red'"
            >{{ getPercentChangeDay() }}</span
          >

          <span
            v-if="this.chartMode == 'month'"
            :style="positiveTotal ? 'color:#22c9b6' : 'color:red'"
            >{{ getPercentChangeMonth() }}</span
          >

          <span
            v-if="this.chartMode == 'year'"
            :style="positiveTotal ? 'color:#22c9b6' : 'color:red'"
            >{{ getPercentChangeYear() }}</span
          >

          <span
            v-if="this.chartMode == 'ytd'"
            :style="positiveTotal ? 'color:#22c9b6' : 'color:red'"
            >{{ getPercentChangeYTD() }}</span
          >

          <span
            v-if="this.chartMode == 'all'"
            :style="positiveTotal ? 'color:#22c9b6' : 'color:red'"
            >{{ getPercentChangeAll() }}</span
          >
        </div>
      </label>
      <div class="tab-content">
        <div id="landing_charts" class="landing_charts">
          <div class="wrapper_chart_insights">
            <p class="expand_chart" @click="toggleModalExpandChart()">
              {{ $t("msg.expand_chart") }}
              <img
                src="../../assets/images/external-link.svg"
                alt="external-link"
              />
            </p>
            <a href="#" @click="toggleModalPriceHist()">{{
              $t("msg.price_history_list")
            }}</a>
          </div>

          <div class="column landing_charts_label p0">
            <div style="display: flex; align-items: center">
              <!-- <span class="landing_charts_label_block"></span> -->
              <p>
                {{ $tc("msg.price", 1) }}
                BLUE | USDT
              </p>
            </div>
            <div
              class="combo_buttons_charts"
              :class="{ loading_action: chartLoading }"
            >
              <!-- <a
                class="link_switch"
                style="padding: 0 5px !important"
                @click="toggleChart('hour')"
                :class="{ link_switch_active: chartMode == 'hour' }"
                :disabled="chartMode == 'hour' || chartLoading"
                >1H</a
              > -->
              <a
                class="link_switch"
                style="padding: 0 5px !important"
                @click="toggleChart('day')"
                :class="{ link_switch_active: chartMode == 'day' }"
                :disabled="chartMode == 'day' || chartLoading"
                >1D</a
              >
              <a
                class="link_switch"
                style="padding: 0 5px !important"
                @click="toggleChart('week')"
                :class="{ link_switch_active: chartMode == 'week' }"
                :disabled="chartMode == 'week' || chartLoading"
                >1{{ $t("msg.w") }}</a
              >
              <a
                class="link_switch"
                style="padding: 0 5px !important"
                @click="toggleChart('month')"
                :class="{ link_switch_active: chartMode == 'month' }"
                :disabled="chartMode == 'month' || chartLoading"
                >1M</a
              >
              <a
                class="link_switch"
                style="padding: 0 5px !important"
                @click="toggleChart('year')"
                :class="{ link_switch_active: chartMode == 'year' }"
                :disabled="chartMode == 'year' || chartLoading"
                >1Y</a
              >
              <a
                class="link_switch"
                style="padding: 0 5px !important"
                @click="toggleChart('ytd')"
                :class="{ link_switch_active: chartMode == 'ytd' }"
                :disabled="chartMode == 'ytd' || chartLoading"
                >YTD</a
              >
              <a
                class="link_switch"
                style="padding: 0 5px !important"
                @click="toggleChart('all')"
                :class="{ link_switch_active: chartMode == 'all' }"
                :disabled="chartMode == 'all' || chartLoading"
                >{{ $t("msg.all") }}</a
              >
            </div>
          </div>
          <div style="padding: 0.75rem 0">
            <chart-line-custom
              @chartLoaded="setChartLoading(false)"
              @chartLoading="setChartLoading(true)"
              :chartData="chartParams"
              :bluValue="bluValue[0]"
            ></chart-line-custom>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ChartLineAll from "./charts_component/ChartLineAll";
import ChartLineLatest from "./charts_component/ChartLineLatest";
import ChartLineCustom from "./charts_component/ChartLineCustom";

export default {
  created() {
    this.checkIfMobile();
  },
  mounted() {
    this.toggleChart("all");
    window.addEventListener("resize", this.checkIfMobile);
  },
  data: () => ({
    chartParams: false,
    startDateChartAll: "2018-12-04T00:00:09.0Z",
    positiveTotal: "",
    chartsHour: {
      data: false,
      step: "",
      type: "hour",
      min: "",
    },
    chartsDay: {
      data: false,
      step: "",
      type: "day",
      min: "",
    },
    chartsWeek: {
      data: false,
      step: "",
      type: "week",
      min: "",
    },

    chartsMonth: {
      data: false,
      step: "",
      type: "month",
      min: "",
    },

    chartsYear: {
      data: false,
      step: "",
      type: "year",
      min: "",
    },

    chartsYTD: {
      data: false,
      step: "",
      type: "ytd",
      min: "",
    },

    chartsAll: {
      data: false,
      step: "",
      type: "all",
      min: "",
    },

    chartLoading: true,
    chartMode: "all",
    isMobile: false,
  }),
  components: {
    ChartLineAll,
    ChartLineLatest,
    ChartLineCustom,
  },
  methods: {
    toggleModalExpandChart() {
      this.$emit("toggleModalExpandChart");
    },

    toggleModalPriceHist() {
      this.$emit("toggleModalPriceHist");
    },

    getPercentChangeAll() {
      let firstPrice = this.chartsAll.data[0]
        ? this.chartsAll.data[0].close
        : 0;
      let currentlyPrice = this.bluValue[0] ? this.bluValue[0].value : 0;

      let total = ((currentlyPrice - firstPrice) / firstPrice) * 100;

      if (total >= 0) {
        this.positiveTotal = true;
        return "+" + total.toFixed(2) + "%";
      } else {
        this.positiveTotal = false;
        return total.toFixed(2) + "%";
      }
    },

    getPercentChangeHour() {
      let firstPrice = this.chartsHour.data[0].close;
      let currentlyPrice = this.bluValue[0].value;

      let total = ((currentlyPrice - firstPrice) / firstPrice) * 100;

      if (total >= 0) {
        this.positiveTotal = true;
        return "+" + total.toFixed(2) + "%";
      } else {
        this.positiveTotal = false;
        return total.toFixed(2) + "%";
      }
    },

    getPercentChangeDay() {
      let firstPrice = this.chartsDay.data[0].close;
      let currentlyPrice = this.bluValue[0].value;

      let total = ((currentlyPrice - firstPrice) / firstPrice) * 100;

      if (total >= 0) {
        this.positiveTotal = true;
        return "+" + total.toFixed(2) + "%";
      } else {
        this.positiveTotal = false;
        return total.toFixed(2) + "%";
      }
    },

    getPercentChangeYear() {
      let firstPrice = this.chartsYear.data[0]
        ? this.chartsYear.data[0].close
        : 0;

      let currentlyPrice = this.bluValue[0] ? this.bluValue[0].value : 0;

      let total = ((currentlyPrice - firstPrice) / firstPrice) * 100;

      if (total >= 0) {
        this.positiveTotal = true;
        return "+" + total.toFixed(2) + "%";
      } else {
        this.positiveTotal = false;
        return total.toFixed(2) + "%";
      }
    },

    getPercentChangeYTD() {
      let firstPrice = this.chartsYTD.data[0]
        ? this.chartsYTD.data[0].close
        : 0;

      let currentlyPrice = this.bluValue[0] ? this.bluValue[0].value : 0;

      let total = ((currentlyPrice - firstPrice) / firstPrice) * 100;

      if (total >= 0) {
        this.positiveTotal = true;
        return "+" + total.toFixed(2) + "%";
      } else {
        this.positiveTotal = false;
        return total.toFixed(2) + "%";
      }
    },

    getPercentChangeMonth() {
      let firstPrice = this.chartsMonth.data[0].close;
      let currentlyPrice = this.bluValue[0].value;

      let total = ((currentlyPrice - firstPrice) / firstPrice) * 100;

      if (total >= 0) {
        this.positiveTotal = true;
        return "+" + total.toFixed(2) + "%";
      } else {
        this.positiveTotal = false;
        return total.toFixed(2) + "%";
      }
    },

    getPercentChangeWeek() {
      let firstPrice = this.chartsWeek.data[0].close;
      let currentlyPrice = this.bluValue[0].value;

      let total = ((currentlyPrice - firstPrice) / firstPrice) * 100;

      if (total >= 0) {
        this.positiveTotal = true;
        return "+" + total.toFixed(2) + "%";
      } else {
        this.positiveTotal = false;
        return total.toFixed(2) + "%";
      }
    },

    setChartLoading(bol) {
      this.chartLoading = bol;
    },

    // step 1 ...........................................................................
    toggleChart(mode) {
      this.chartMode = mode;
      if (mode == "hour") {
        if (!this.chartsHour.data) {
          this.getHistoryHour();
        } else {
          this.setChart("hour");
        }
      }

      if (mode == "day") {
        if (!this.chartsDay.data) {
          this.getHistoryDay();
        } else {
          this.setChart("day");
        }
      }

      if (mode == "week") {
        if (!this.chartsWeek.data) {
          this.getHistoryWeek();
        } else {
          this.setChart("week");
        }
      }

      if (mode == "month") {
        if (!this.chartsMonth.data) {
          this.getHistoryMonth();
        } else {
          this.setChart("month");
        }
      }

      if (mode == "year") {
        if (!this.chartsYear.data) {
          this.getHistoryYear();
        } else {
          this.setChart("year");
        }
      }

      if (mode == "ytd") {
        if (!this.chartsYTD.data) {
          this.getHistoryYTD();
        } else {
          this.setChart("ytd");
        }
      }

      if (mode == "all") {
        if (!this.chartsAll.data) {
          this.getHistoryAll();
        } else {
          this.setChart("all");
        }
      }
    },

    // step 2 ...........................................................................

    async getHistoryHour() {
      let dateStart = new Date();
      let dateEnd = new Date();
      dateEnd.setHours(dateEnd.getHours() - 1);
      let endHour = this.sharedActions.formatDateTimeHistory(dateEnd);

      dateStart.setHours(dateStart.getHours() - 2);
      let startHour = this.sharedActions.formatDateTimeHistory(dateStart);

      let params = {
        start: startHour + ".0Z",
        end: endHour + ".0Z",
        pair: "usdt",
        period: 1,
        sumbols: "blu",
      };

      let resp = await this.$store.dispatch("getCurrenciesHistory", params);

      this.chartsHour.data = resp.data[0].history;
      this.getMinStep(resp.data[0].history, "hour");
    },

    async getHistoryDay() {
      let date = new Date();
      let endHour = this.sharedActions.formatDateTimeHistory(date);
      date.setHours(0);
      date.setMinutes(0);
      let startHour = this.sharedActions.formatDateTimeHistory(date);
      let params = {
        start: startHour + ".0Z",
        end: endHour + ".0Z",
        pair: "usdt",
        period: 60,
        sumbols: "blu",
      };
      let resp = await this.$store.dispatch("getCurrenciesHistory", params);
      this.chartsDay.data = resp.data[0].history;

      this.getMinStep(resp.data[0].history, "day");
    },

    async getHistoryWeek() {
      let date = new Date();
      let endHour = this.sharedActions.formatDateTimeHistory(date);
      date.setDate(date.getDate() - 7);
      let startHour = this.sharedActions.formatDateTimeHistory(date);

      let params = {
        start: startHour + ".0Z",
        end: endHour + ".0Z",
        pair: "usdt",
        period: 720,
        sumbols: "blu",
      };

      console.log(startHour);
      console.log(endHour);

      let resp = await this.$store.dispatch("getCurrenciesHistory", params);
      this.chartsWeek.data = resp.data[0].history;

      this.setChart("week");
    },

    async getHistoryMonth() {
      let date = new Date();
      let endHour = this.sharedActions.formatDateTimeHistory(date);
      date.setMonth(date.getMonth() - 1);
      let startHour = this.sharedActions.formatDateTimeHistory(date);
      let params = {
        start: startHour + ".0Z",
        end: endHour + ".0Z",
        pair: "usdt",
        period: "1D",
        sumbols: "blu",
      };
      let resp = await this.$store.dispatch("getCurrenciesHistory", params);
      this.chartsMonth.data = resp.data[0].history;
      this.setChart("month");
    },

    async getHistoryYear() {
      let date = new Date();
      let endHour = this.sharedActions.formatDateTimeHistory(date);
      date.setFullYear(date.getFullYear() - 1);
      let startHour = this.sharedActions.formatDateTimeHistory(date);
      let params = {
        start: startHour + ".0Z",
        end: endHour + ".0Z",
        pair: "usdt",
        period: 720,
        sumbols: "blu",
      };
      let resp = await this.$store.dispatch("getCurrenciesHistory", params);
      this.chartsYear.data = resp.data[0].history;
      this.setChart("year");
    },

    async getHistoryYTD() {
      let date = new Date();
      let endHour = this.sharedActions.formatDateTimeHistory(date);
      date.setFullYear(date.getFullYear(), 0, 1);

      let startHour = this.sharedActions.formatDateTimeHistory(date);

      let params = {
        start: startHour + ".0Z",
        end: endHour + ".0Z",
        pair: "usdt",
        period: 720,
        sumbols: "blu",
      };

      let resp = await this.$store.dispatch("getCurrenciesHistory", params);
      this.chartsYTD.data = resp.data[0].history;
      this.setChart("ytd");
    },

    async getHistoryAll() {
      let date = new Date();
      let endHour = this.sharedActions.formatDateTimeHistory(date);
      date.setFullYear(2018);
      let startHour = this.sharedActions.formatDateTimeHistory(
        this.startDateChartAll
      );

      let params = {
        start: startHour + ".0Z",
        end: endHour + ".0Z",
        pair: "usdt",
        period: 720,
        sumbols: "blu",
      };
      let resp = await this.$store.dispatch("getCurrenciesHistory", params);
      this.chartsAll.data = resp.data[0].history;

      this.getMinStep(resp.data[0].history, "all");
      this.$emit("createPriceHist", this.chartsAll);
    },

    getMinStep(resp, type) {
      let max = 0;
      let min = 1000;
      let step = "";

      for (let i in resp) {
        if (resp[i].close < min) {
          min = resp[i].close;
        }
        if (resp[i].close > max) {
          max = resp[i].close;
        }
      }

      let minFixed = min.toFixed();
      min = min.toFixed(2);
      max = max.toFixed(2);
      step = (max - min).toFixed(2) / 2;

      min = min - step * 2;

      if (type == "hour") {
        // min = min + 0.03
        this.chartsHour.min = min.toFixed(2);
        this.chartsHour.step = step;
        this.setChart("hour");
      }

      if (type == "day") {
        this.chartsDay.min = min.toFixed(2);
        this.chartsDay.step = step;
        this.setChart("day");
      }

      if (type == "all") {
        this.chartsAll.min = min.toFixed();
        this.chartsAll.step = step.toFixed();
        this.setChart("all");
      }
    },

    //step 3 ...........................................................................
    setChart(mode) {
      if (mode == "hour") {
        this.chartParams = this.chartsHour;
      } else if (mode == "day") {
        this.chartParams = this.chartsDay;
      } else if (mode == "week") {
        this.chartParams = this.chartsWeek;
      } else if (mode == "month") {
        this.chartParams = this.chartsMonth;
      } else if (mode == "year") {
        this.chartParams = this.chartsYear;
      } else if (mode == "ytd") {
        this.chartParams = this.chartsYTD;
      } else if (mode == "all") {
        this.chartParams = this.chartsAll;
      }
    },

    // step4 .........................................................................

    currencyFormat(num) {
      if (num) {
        return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      } else {
        return 0;
      }
    },

    checkIfMobile() {
      let w = window,
        x = w.innerWidth;

      if (x > 900) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    },
  },
  computed: {
    ...mapGetters(["currencies", "btcValue", "bluValue"]),
  },
  watch: {},
};
</script>



// WEBPACK FOOTER //
// src/components/public/GeneralCharts.vue